export default __webpack_public_path__ + "pgnv-assets/42ef42ab45bc07a21769d8f4a9ec0d0e.png";